module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "body-border-right body-border-right-full pl-0",
    attrs: {
      "md8": ""
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('p', {
    staticClass: "text-xs-left medium"
  }, [_vm._v("Nuevo tipo de limpieza")])]), _vm._v(" "), _c('v-container', {
    staticClass: "grid-list-xl",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "form-section text-xs-left",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "label-section mb-2"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nombre del tipo de limpieza")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "input-form",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text",
      "placeholder": "Ejem. Ocupado sucio"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "label-section mb-2"
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Siglas del tipo de limpieza")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.code_setting),
      expression: "model.code_setting"
    }],
    staticClass: "input-form",
    attrs: {
      "id": "code",
      "name": "code_setting",
      "type": "text",
      "placeholder": "Ejem. OS"
    },
    domProps: {
      "value": (_vm.model.code_setting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.code_setting = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "label-section mb-2"
  }, [_c('label', {
    attrs: {
      "for": "color"
    }
  }, [_vm._v("Color picker")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "color-picker"
  }, [_c('v-menu', {
    attrs: {
      "offset-x": "",
      "close-on-content-click": false,
      "top": true,
      "full-width": true
    },
    model: {
      value: (_vm.showColorPicker),
      callback: function($$v) {
        _vm.showColorPicker = $$v
      },
      expression: "showColorPicker"
    }
  }, [_c('div', {
    slot: "activator"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.color_setting),
      expression: "model.color_setting"
    }],
    staticClass: "input-form",
    attrs: {
      "id": "color",
      "name": "color_setting",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.color_setting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.color_setting = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "current-color",
    style: (_vm.currentPicker)
  })]), _vm._v(" "), _c('v-list', {
    staticClass: "menu-color-picker"
  }, [_c('button', {
    staticClass: "btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showColorPicker = false
      }
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), _c('chrome-picker', {
    attrs: {
      "value": _vm.colors
    },
    on: {
      "input": _vm.onUpdateColor
    }
  })], 1)], 1)], 1)])])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "grid-list-md text-xs-left mt-3",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "label-section mb-2"
  }, [_c('label', [_vm._v("Seleccione el ícono")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "form-section text-xs-left",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.states), function(state) {
    return _c('v-flex', {
      key: state.id,
      attrs: {
        "md1": ""
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.model.stateSelected),
        expression: "model.stateSelected"
      }],
      attrs: {
        "type": "radio",
        "hidden": "",
        "name": "icons",
        "id": state.id
      },
      domProps: {
        "value": state,
        "checked": _vm._q(_vm.model.stateSelected, state)
      },
      on: {
        "change": function($event) {
          _vm.updateIcon()
        },
        "__c": function($event) {
          _vm.model.stateSelected = state
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "select-icon-states",
      attrs: {
        "for": state.id
      }
    }, [_c('img', {
      attrs: {
        "src": state.imageUrl,
        "alt": ""
      }
    })])])
  }))], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "form-section text-xs-left"
  }, [_c('div', {
    staticClass: "label-section mt-4 mb-2"
  }, [_c('label', [_vm._v("Subir ícono")])]), _vm._v(" "), _c('file-upload-container', {
    staticClass: "mb-3",
    attrs: {
      "label-for": ("image-" + (_vm.model.image.id)),
      "image-url": _vm.model.image.imageUrl,
      "min-resolution": 20,
      "max-resolution": 20
    },
    on: {
      "upload": _vm.onUploadImage
    }
  })], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save mr-3",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.createSetting
    }
  }, [_vm._v("\n\t\t\t\tGuardar\n\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-cancel",
    attrs: {
      "to": _vm.settingsHref
    }
  }, [_vm._v("\n\t\t\t\tCancelar\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('p', {
    staticClass: "text-xs-center medium"
  }, [_vm._v("Vista previa")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-layout', {
    staticClass: "new-state-container",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('room-status', {
    class: {
      'topProperty': !_vm.model.name
    },
    attrs: {
      "background-color": _vm.model.color_setting,
      "status-icon-img": _vm.model.image.imageUrl !== _vm.preimage ? _vm.model.image.imageUrl : _vm.model.stateSelected.imageUrl,
      "name": _vm.model.code_setting,
      "room": _vm.model
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.model.name))])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Tipo de habitación")]), _vm._v(" "), _c('th', [_vm._v("Tiempo estándar")]), _vm._v(" "), (_vm.settingId) ? _c('th', [_vm._v(" ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.model.standardTime), function(roomtype) {
    return (roomtype.id) ? _c('tr', {
      key: roomtype.id
    }, [_c('td', [_vm._v(_vm._s(roomtype.name))]), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "time-standard-input",
      attrs: {
        "type": "number",
        "suffix": "min",
        "min": "1",
        "step": "1",
        "hide-details": ""
      },
      on: {
        "keyup": function($event) {
          _vm.toInt(roomtype.time)
        }
      },
      model: {
        value: (roomtype.time),
        callback: function($$v) {
          roomtype.time = _vm._n($$v)
        },
        expression: "roomtype.time"
      }
    })], 1), _vm._v(" "), (_vm.settingId) ? _c('td', {
      staticClass: "td-icon"
    }, [_c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openCheckList(roomtype)
        }
      }
    }, [_vm._v("playlist_add")])], 1) : _vm._e()]) : _vm._e()
  }))])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "685",
      "content-class": "modal-dashboard"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\tAgregar tareas\n\t\t\t\t"), _c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": "",
      "pr-2": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask),
      expression: "newTask"
    }],
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newTask)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTask($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTask = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "pl-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-add",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.addTask
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n\t\t\t\t\t\t\tAgregar\n\t\t\t\t\t\t")], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": "",
      "mt-3": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "key-value": "text",
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-switch": false,
      "include-settings": false,
      "include-search": false,
      "include-options": true,
      "include-delete-single": true
    },
    on: {
      "on-delete-event": _vm.deleteRow
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.text))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-save mr-3 mb-2",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.saveCheckList($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tGuardar\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-067b9d80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/settings/Create.vue
// module id = 1577
// module chunks = 9